import React from 'react'
import PropTypes from 'prop-types'

import LandingPageCategoryBox from './LandingPageCategoryBox'

function LandingPageCategoriesContainer({ competitionSlug, activeSectionSlug, categories }) {
  return (
    <div className="row">
      {categories.map((category) => {
        return (
          <LandingPageCategoryBox
            key={category.slug}
            category={category}
            competitionSlug={competitionSlug}
            activeSectionSlug={activeSectionSlug}
            imgPath={require(`images/competitions/digital_art/categories/${competitionSlug}_${category.slug}.jpg`)}
          />
        )
      })}
    </div>
  )
}

LandingPageCategoriesContainer.propTypes = {
  competitionSlug: PropTypes.string.isRequired,
  activeSectionSlug: PropTypes.string.isRequired,
  categories: PropTypes.array.isRequired,
}

export default LandingPageCategoriesContainer
